/**
 * Mega Menu Portal Logic (Rewrite)
 * Moves the menu to body and handles interaction state.
 */

(function () {
    const PORTAL_ID = 'mega-menu-portal-root';
    const ACTIVE_CLASS = 'is-active';
    const BODY_LOCK_CLASS = 'mm-lock-scroll';
    let activePanelId = null;

    function initMegaMenu() {
        const portal = document.getElementById(PORTAL_ID);
        if (!portal) return;

        // 1. TELEPORTATION: Move to body to kill stacking context issues
        if (portal.parentElement !== document.body) {
            document.body.appendChild(portal);
        }

        // Ensure it's visible to CSS (we used display:none in liquid to prevent FOUC)
        portal.style.display = 'block';

        // 2. EVENT DELEGATION
        // Handle Open Triggers
        document.querySelectorAll('[data-megamenu-trigger]').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation(); // prevent bubbling
                const type = trigger.getAttribute('data-megamenu-trigger'); // 'mental' or 'chronic'
                openMenu(type);
            });
        });

        // Handle Close Triggers (Backdrop & Buttons)
        // 1. Backdrop Click - Close menu when clicking outside panels
        portal.addEventListener('click', (e) => {
            // Only process if menu is active
            if (!portal.classList.contains(ACTIVE_CLASS)) {
                return;
            }

            // Check if click is on a panel or close button
            const clickedPanel = e.target.closest('.mega-menu-panel');
            const clickedCloseBtn = e.target.closest('[data-close-megamenu]');
            
            // If clicking outside panel (on backdrop), close the menu
            // Close button clicks are handled separately below
            if (!clickedPanel && !clickedCloseBtn) {
                e.preventDefault();
                e.stopPropagation();
                console.log('Backdrop clicked - closing menu');
                closeMenu();
            }
        });

        // Get backdrop element
        const backdrop = portal.querySelector('.mega-menu-backdrop');

        // Prevent clicks inside panels from closing the menu
        const panels = portal.querySelectorAll('.mega-menu-panel');
        panels.forEach(panel => {
            panel.addEventListener('click', (e) => {
                // Don't stop propagation for close buttons - let them work
                if (!e.target.closest('[data-close-megamenu]')) {
                    e.stopPropagation(); // Prevent clicks inside panel from bubbling to portal
                }
            });
        });

        // 2. Buttons (inside panels) - Close buttons
        portal.querySelectorAll('[data-close-megamenu]').forEach(btn => {
            // Avoid double-binding if btn IS the backdrop
            if (btn !== backdrop) {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    closeMenu();
                });
            }
        });

        // Handle ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && portal.classList.contains(ACTIVE_CLASS)) {
                closeMenu();
            }
        });

        // 3. ACTIONS
        function openMenu(type) {
            console.log('Opening mega menu:', type);
            
            // Close any existing open menu first
            if (portal.classList.contains(ACTIVE_CLASS)) {
                closeMenu();
                // Wait for close animation before opening new one
                setTimeout(() => {
                    openMenu(type);
                }, 100);
                return;
            }

            // Set active panel data attribute for CSS selectors
            portal.setAttribute('data-active-panel', type);
            activePanelId = type;

            // Activate Portal (triggers CSS animations for blur and panel)
            portal.classList.add(ACTIVE_CLASS);

            // Lock body scroll and apply blur
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.classList.add(BODY_LOCK_CLASS, 'is-mm-active');
            document.body.style.overflow = 'hidden';
            
            console.log('Menu opened - backdrop should be clickable');
        }

        function closeMenu() {
            if (!portal.classList.contains(ACTIVE_CLASS)) {
                return; // Already closed
            }

            console.log('Closing mega menu');

            // Get scroll position before removing fixed positioning
            const scrollY = document.body.style.top;

            // Deactivate Portal (triggers CSS animations)
            portal.classList.remove(ACTIVE_CLASS);

            // Remove Blur effect from content
            document.body.classList.remove('is-mm-active');

            // Release Scroll Lock - restore scrolling and responsiveness
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
            document.body.classList.remove(BODY_LOCK_CLASS);

            // Restore scroll position
            if (scrollY) {
                const scrollPosition = parseInt(scrollY.replace('px', '') || '0') * -1;
                window.scrollTo(0, scrollPosition);
            }

            // Clear active panel attribute after animation completes
            setTimeout(() => {
                if (!portal.classList.contains(ACTIVE_CLASS)) {
                    portal.removeAttribute('data-active-panel');
                    activePanelId = null;
                    console.log('Menu fully closed');
                }
            }, 500);
        }
    }

    // Init on DOM Ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMegaMenu);
    } else {
        initMegaMenu();
    }

    // Re-init on Shopify Section Load (Design Mode support)
    document.addEventListener('shopify:section:load', initMegaMenu);

})();
